<a matTooltip="Notifications" class="nav-link p-0 black" role="button" (click)="viewNotifications()" aria-expanded="false">
    <mat-icon [matBadge]="count" matBadgeSize="small" matBadgeColor="warn">notifications</mat-icon>
</a>